module.exports = __webpack_public_path__ + "img/Library.bf122ebc.png";